import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { fetchFileCommentCount } from '../api/fileComments'
import { getMediaCid } from 'utils'
import { setCommentsCounter } from 'redux/actions/comments'

export const useFileCommentsCounts = (oid: string, media: string[]) => {
  const dispatch = useDispatch()
  const { cdn, rid } = useSelector((s: RootState) => s.config.config)
  const counters = useSelector((s: RootState) => s.comments.commentsCounter)
  const total = counters[oid] || 0
  const hashes = useMemo(() => media.map((url) => getMediaCid({ url, cdn, rid }) || ''), [media, cdn, rid])
  const hashesKey = hashes.join('|')
  useEffect(() => {
    let cancelled = false
    const remaining = hashesKey.split('|').filter(Boolean)
    // Bound parallel requests even for a result containing many files.
    const worker = async () => {
      while (remaining.length && !cancelled) {
        const hash = remaining.shift()!
        try {
          const count = await fetchFileCommentCount(oid, hash)
          if (!cancelled && typeof count === 'number') dispatch(setCommentsCounter({ key: `${oid}-${hash}`, count }))
        } catch {
          /* Counters are optional; keep the last known value on network failure. */
        }
      }
    }
    Promise.all([worker(), worker(), worker()])
    return () => {
      cancelled = true
    }
  }, [dispatch, oid, hashesKey, total])
  return hashes.map((hash) => counters[`${oid}-${hash}`] ?? 0)
}
